import { render, staticRenderFns } from "./AlertEventABMComponent.vue?vue&type=template&id=622c880e&scoped=true"
import script from "./AlertEventABMComponent.js?vue&type=script&lang=js&external"
export * from "./AlertEventABMComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertEventABMComponent.vue?vue&type=style&index=0&id=622c880e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c880e",
  null
  
)

export default component.exports